var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconBookmark = function SvgIconBookmark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M5 16.485V21a1 1 0 0 0 1.53.848L12 18.429l5.47 3.419A1 1 0 0 0 19 21V4.5a1.75 1.75 0 0 0-1.75-1.75H6.75A1.75 1.75 0 0 0 5 4.5zm2-1.79V4.75h10v9.946l-4.47-2.794a1 1 0 0 0-1.06 0zm10 2.36v2.14l-4.47-2.793a1 1 0 0 0-1.06 0L7 19.196v-2.142l5-3.125z",
    clipRule: "evenodd"
  })));
};
export default SvgIconBookmark;